var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('multi-message-editor-with-media-input',{staticClass:"send-message-editor",staticStyle:{"margin-top":"0 !important","margin-bottom":"0 !important"},attrs:{"setup":{
      'func': _vm.changeMessageHandler,
      'args': {
        'model': _vm.action.action,
        'key': 'variants',
        'prefix': 'flow_send_message_sidebar_',
        'validation': 'required',
        'pinButtons': _vm.PinMessageParts.PinNoEditable,
        'hasMedia': true,
        'availableButtonsTypes': _vm.availableButtonsTypes,
        'buttonsHelpView': _vm.buttonsHelpView,
        'placeholders': _vm.placeholders,
        'targetToUpload': {
          'target': 'target',
          'target_id': _vm.board,
        },
        'settingsStructure': {
          'pin': false,
          'disable_link_preview': false,
          'disable_notify': false,
          'remove_previous': false,
          'protect_content': false,
          'remove_after': 0,
        },
        'customMediaTypes': _vm.node.nodeProps.customMediaTypes,
      }
    }}},[_c('div',{staticClass:"flex gap-2",attrs:{"slot":"titleButton"},slot:"titleButton"},[_c('a-button',{staticClass:"px-1 p-0 flex justify-center items-center",class:{'active': _vm.typingAction},on:{"click":_vm.switchTyping}},[_c('span',{staticClass:"material-icons"},[_vm._v(" "+_vm._s(_vm.typingAction ? 'timer_off' : 'timer')+" ")])])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }